import script from "./PhotoBooth.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoBooth.vue?vue&type=script&setup=true&lang=js"

import "./PhotoBooth.vue?vue&type=style&index=0&id=356f0893&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356f0893"]])

export default __exports__